import React from 'react'

import {Icon, Input, Modal} from 'antd'

const helpText = () =>
   Modal.info({
      title:   'Writing Queries',
      width:   '50%',
      content: (
         <div>
            <p style={{marginBottom: '1.5em'}}>
               Simple rules to filter the resultset. Queries takes the form
               {' '}<code>expr := &lt;k || val&gt; &lt;op&gt; &lt;k || val&gt;</code>,
               {' '}<code>for example: proto/tm.rssi &gt; 100</code>.
            </p>

            <p style={{marginBottom: '1.5em'}}>
               <code>k</code>
               {' '}
               may be any nested path in dot notation, op may be one of the following equality
               operators:
               {' '}
               <code>==</code>
               ,
               {' '}
               <code>!=</code>
               ,
               {' '}
               <code>&lt;</code>
               ,
               {' '}
               <code>&gt;=</code>
               {' '}
               or
               {' '}
               <code>&gt;=</code>
               .
               <code>val</code> must be a scaler value
               {' '}
               <code>string := "abc" or 'def'</code>
               ,
               {' '}
               <code>integer := 78491</code>
               {' '}
               or
               {' '}
               <code>float := 3.14</code>
               .
            </p>

            <p style={{marginBottom: '1.5em'}}>
               Some basic arithematic can be performed on k and val, like matching on rssi in dBm:
               {' '}<code>-50 &lt; proto/tm.rssi * -0.5</code>
            </p>
         </div>
      ),
      okText: 'Got it!'
   })

export const QueryInput = ({query, update}) => (
   <div>
      <Input
         type="textarea"
         placeholder="Query, ie: proto/tm.network_lvl > 2"
         onChange={ev => update(ev.target.value)}
         autosize={{minRows: 2, maxRows: 6}}
         onBlur={() => update(query, true)}
         value={query}
      />

      <div className="text-right">
         <a style={{padding: '5px', display: 'inline-block'}} onClick={helpText}>
            <Icon type="question-circle" /> Writing queries
         </a>
      </div>
   </div>
)

QueryInput.propTypes = {
   query:            React.PropTypes.string.isRequired,
   update:           React.PropTypes.func.isRequired,
   availableColumns: React.PropTypes.array.isRequired
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/query/QueryInput.jsx